import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import {
  BaseCssProperties,
  ProviderClass,
  TextItemWidgetConfig,
  UiZoneWidgetAttributeConfig,
  baseCssConfigStyle,
} from '@finxone-platform/shared/sys-config-types';
import { ConfigService } from '../../../../lib/services/config-service/config-service.service';

@Component({
  standalone: false,
  selector: 'finxone-platform-sumsub-widget',
  templateUrl: './sumsub-widget.component.html',
  styleUrls: ['./sumsub-widget.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class SumsubWidgetComponent implements OnInit {
  isWorkflow = false;
  attri: UiZoneWidgetAttributeConfig;
  contentStyle: baseCssConfigStyle; //property to set css in main div
  public applicationCompleteMessage: string;

  constructor(private configService: ConfigService, public dataIn: ProviderClass<TextItemWidgetConfig>) {}

  ngOnInit() {
    if (this.dataIn != undefined && this.dataIn != null) {
      this.attri = this.dataIn.attri;
      this.applicationCompleteMessage = this.attri.widgetProperties?.textContent;
    }

    this.contentStyle = this.configService.getSpecificBaseCssStyle(this.attri, [
      BaseCssProperties.MARGIN,
      BaseCssProperties.PADDING,
      BaseCssProperties.BORDER,
    ]);
    this.isWorkflow = this.configService.getActiveConfigType().isWorkflow;
  }
}
